import { z } from 'zod';
export const BulletSchema = z.object({
    body: z.string().min(1),
    speaker: z.string().optional(),
    isDirectQuote: z.boolean().default(false),
    ambiguityFlag: z.string().optional(), // Claude's note about what's ambiguous
});
export const TopicSchema = z.object({
    title: z.string().min(1),
    kind: z.enum(['discussion', 'action_items', 'decisions', 'notes']).default('discussion'),
    bullets: z.array(BulletSchema),
});
//# sourceMappingURL=topic.js.map